<template>
  <div class="nutbody">
    <keep-alive>
      <router-view :urlBase="urlBase" :token="token" :username="username"></router-view>
    </keep-alive>
  </div>
</template>

<script>
import Home from "./Home";
import Avzyz from "./Avzyz";
import Sezyz from "./Sezyz";
import Suduzyz from "./Suduzyz";
import Nrenvip from "./Nrenvip";
import Newfhk from "./Newfhk";
import Tnbt from "./Tnbt";
import Sobt from "./Sobt";
import Incestgames from "./Incestgames";
import Newgamesbox from "./Newgamesbox";
const routes=[
  {path:'/',component:Home},
  {path:'/avzyz',component:Avzyz},
  {path:'/sezyz',component:Sezyz},
  {path:'/suduzyz',component:Suduzyz},
  {path:'/nrenvip',component:Nrenvip},
  {path:'/newfhk',component:Newfhk},
  {path:'/tnbt',component:Tnbt},
  {path:'/sobt',component:Sobt},
  {path:'/incestgames',component:Incestgames},
  {path:'/newgamesbox',component:Newgamesbox},
]
export default {
  name: "Nutbody",
  props: {
    urlBase: String,
    token: String,
    username:String
  },
  routes:routes,
  components: {
  },
  data: function() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
